export { SkeletonLoader as Skeleton } from './Skeleton';
